import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/ibm-aiops-training/ibm-aiops-training/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineNotification = makeShortcode("InlineNotification");
const Accordion = makeShortcode("Accordion");
const AccordionItem = makeShortcode("AccordionItem");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`In this section you will connect to the existing LDAP Server and create a user with Administrative rights:`}</p>
    <h2>{`🚀 TASK: Create the LDAP Connection`}</h2>
    <a href="https://www.ibm.com/docs/en/cloud-paks/cloud-pak-aiops/4.6.0?topic=authentication-configuring-ldap-connections" target="_blank">🌏 Documentation for the Task: Configuring LDAP connection</a>
    <p>{`Connect to the existing LDAP Server using the following parameters:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-yaml"
      }}>{`Server type:          Custom

Base DN:              dc=ibm,dc=com
Bind DN:              cn=admin,dc=ibm,dc=com
Bind DN password:     P4ssw0rd! 

LDAP server URL:      ldap://openldap.openldap:389
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-yaml"
      }}>{`Group filter:         (&(cn=%v)(objectclass=groupOfUniqueNames))
User filter:          (&(uid=%v)(objectclass=Person))     <-- Thats the only value you should have to change
Group ID map:         *:cn
User ID map:          *:uid
Group member ID map:  groupOfUniqueNames:uniqueMember
`}</code></pre>
    <InlineNotification kind="success" mdxType="InlineNotification">
      <p>{`🔎 The parameters can also be found in your configuration file `}<inlineCode parentName="p">{`MY_CONFIGURATION.txt`}</inlineCode>{` - section  `}<strong parentName="p">{`2.1 Configure LDAP`}</strong>{` `}</p>
    </InlineNotification>
    <Accordion mdxType="Accordion">
      <AccordionItem title="💡 Solution?" mdxType="AccordionItem">
        <h2>{`Create LDAP provider`}</h2>
        <ol>
          <li parentName="ol">
            <p parentName="li">{`In the `}<inlineCode parentName="p">{`CP4AIOPS`}</inlineCode>{` “Hamburger” Menu select `}<inlineCode parentName="p">{`Administration`}</inlineCode></p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Select `}<inlineCode parentName="p">{`Access Control`}</inlineCode></p>
            <img parentName="li" {...{
              "src": "./../images/20_config.png",
              "alt": "image"
            }}></img>
          </li>
          <li parentName="ol">
            <p parentName="li">{`In the top right Click `}<inlineCode parentName="p">{`Identity provider configuration`}</inlineCode></p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`You might have to re-login with your admin user`}</p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`In the top right Click `}<inlineCode parentName="p">{`New Connection`}</inlineCode></p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Select `}<inlineCode parentName="p">{`LDAP`}</inlineCode>{` from the dropdown`}</p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Click `}<inlineCode parentName="p">{`Next`}</inlineCode></p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Fill out the first section of fields:`}</p>
            <pre parentName="li"><code parentName="pre" {...{
                "className": "language-yaml"
              }}>{`Connection name:      LDAP
Server type:          Custom

Base DN:              dc=ibm,dc=com
Bind DN:              cn=admin,dc=ibm,dc=com
Bind DN password:     P4ssw0rd! 

LDAP server URL:      ldap://openldap.openldap:389

`}</code></pre>
            <img parentName="li" {...{
              "src": "./../images/21_config.png",
              "alt": "image"
            }}></img>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Click `}<inlineCode parentName="p">{`Test connection`}</inlineCode>{`. You should get `}<inlineCode parentName="p">{`Successful connection`}</inlineCode></p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Fill out the rest of the fields:`}</p>
            <pre parentName="li"><code parentName="pre" {...{
                "className": "language-yaml"
              }}>{`Group filter:         (&(cn=%v)(objectclass=groupOfUniqueNames))
User filter:          (&(uid=%v)(objectclass=Person))     <-- Thats the only value you should have to change
Group ID map:         *:cn
User ID map:          *:uid
Group member ID map:  groupOfUniqueNames:uniqueMember
`}</code></pre>
            <img parentName="li" {...{
              "src": "./../images/22_config.png",
              "alt": "image"
            }}></img>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Click `}<inlineCode parentName="p">{`Create`}</inlineCode></p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`You should get a LDAP entry in the provider list`}</p>
            <img parentName="li" {...{
              "src": "./../images/23_config.png",
              "alt": "image"
            }}></img>
          </li>
        </ol>
      </AccordionItem>
    </Accordion>
    <h2>{`🚀 TASK: Create a User in CP4AIOPS`}</h2>
    <a href="https://www.ibm.com/docs/en/cloud-paks/cloud-pak-aiops/4.6.0?topic=control-adding-users" target="_blank">🌏 Documentation for the Task: Adding users</a>
    <p>{`Create a user in CP4AIOPS with Admin rights.`}</p>
    <Accordion mdxType="Accordion">
      <AccordionItem title="💡 Solution?" mdxType="AccordionItem">
        <h2>{`Create User`}</h2>
        <ol>
          <li parentName="ol">
            <p parentName="li">{`In the `}<inlineCode parentName="p">{`CP4AIOPS`}</inlineCode>{` “Hamburger” Menu select `}<inlineCode parentName="p">{`Administration`}</inlineCode></p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Select `}<inlineCode parentName="p">{`Access Control`}</inlineCode></p>
            <img parentName="li" {...{
              "src": "./../images/20_config.png",
              "alt": "image"
            }}></img>
          </li>
          <li parentName="ol">
            <p parentName="li">{`In the top right Click `}<inlineCode parentName="p">{`Add users`}</inlineCode></p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`In the search box type `}<inlineCode parentName="p">{`demo`}</inlineCode></p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Click on the `}<inlineCode parentName="p">{`demo/demo/demo@ibm.com`}</inlineCode>{` line`}</p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Click `}<inlineCode parentName="p">{`Next`}</inlineCode>{` `}</p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Click `}<inlineCode parentName="p">{`Assign roles directly`}</inlineCode></p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Click `}<inlineCode parentName="p">{`Next`}</inlineCode>{` `}</p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Check `}<inlineCode parentName="p">{`Administrator`}</inlineCode>{` role`}</p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Click `}<inlineCode parentName="p">{`Next`}</inlineCode>{` `}</p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Click `}<inlineCode parentName="p">{`Add`}</inlineCode>{` `}</p>
          </li>
        </ol>
        <h2>{`Login as Demo`}</h2>
        <ol>
          <li parentName="ol">
            <p parentName="li">{`In `}<inlineCode parentName="p">{`CP4AIOPS`}</inlineCode>{`, click on the round image in the top right and select `}<inlineCode parentName="p">{`Log Out`}</inlineCode></p>
            <img parentName="li" {...{
              "src": "./../images/24_config.png",
              "alt": "image"
            }}></img>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Click `}<inlineCode parentName="p">{`Logout`}</inlineCode>{` `}</p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Click `}<inlineCode parentName="p">{`Log in`}</inlineCode>{` `}</p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Enter credentials `}<inlineCode parentName="p">{`demo`}</inlineCode>{` and `}<inlineCode parentName="p">{`P4ssw0rd!`}</inlineCode>{` (this information is stored in the LDAP server)`}</p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Welcome back in CP4AIOPS as user Demo`}</p>
          </li>
        </ol>
      </AccordionItem>
    </Accordion>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      